import { OperationalOptimizationsActionTypes } from './constants';

type OperationalOptimizationsAction = { type: string, payload: {} | string };

export const operationalOptimizationsApiResponseSuccess = (actionType: string, data: any): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data },
});

export const operationalOptimizationsApiResponseError = (actionType: string, error: string): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, error },
});

export const operationalOptimizationsGetGroundVsAir = (query: string): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR,
    payload: { query },
});

export const operationalOptimizationsGetOptimizedGroundVsAir = (query: string): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR,
    payload: { query },
});

export const operationalOptimizationsGetGroundVsAirDetails = (query: string): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.GET_GROUND_VS_AIR_DETAILS,
    payload: { query },
});

export const operationalOptimizationsGetOptimizedGroundVsAirDetails = (query: string): OperationalOptimizationsAction => ({
    type: OperationalOptimizationsActionTypes.GET_OPTIMIZED_GROUND_VS_AIR_DETAILS,
    payload: { query },
});
